// extracted by mini-css-extract-plugin
export default {"menuBlock":"AE-z","title":"BE-z","nav":"CE-z","flexCell":"DE-z","facetLink":"EE-z"};